(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cryoglow-product"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateCryoPrice = productRoot => {
      const quantityInput = productRoot.querySelector('input[name="quantity"]');
      if (!quantityInput) return;
      const quantity = Math.max(1,Math.floor(Number(quantityInput.value)||1));
      const unitPrice = Number(productRoot.dataset.unitPrice);
      if (!Number.isFinite(unitPrice)) return;
      let labels = {};
      try { labels = JSON.parse(productRoot.querySelector('[data-cryo-price-labels]')?.textContent || '{}'); } catch {}
      const price = new Intl.NumberFormat(document.documentElement.lang || 'de-DE',{style:'currency',currency:productRoot.dataset.currency || 'EUR'}).format(unitPrice * quantity / 100);
      productRoot.querySelectorAll('[data-product-price],[data-sticky-price]').forEach(element => { element.textContent = price; });
      const priceLabel = productRoot.querySelector('[data-cryo-price-label]');
      if (priceLabel) priceLabel.textContent = quantity > 1 ? labels.total : labels.unit;
      const unitNote = productRoot.querySelector('[data-cryo-unit-note]');
      if (unitNote) unitNote.hidden = quantity <= 1;
    };
    ['input','change'].forEach(eventName => document.addEventListener(eventName,event => {
      if (!event.target.matches('[data-cryo-product] input[name="quantity"]')) return;
      updateCryoPrice(event.target.closest('[data-cryo-product]'));
    }));
  })();
  } catch(e) { console.error(e); }
})();

})();
